// extracted by mini-css-extract-plugin
export default {"grid":"ProjectCaptures_grid__F-h10"};